import React from 'react'
import { useTheme } from "../../../contexts/ThemeProvider";
import { LIGHT_THEME } from '../../../utils/constants';
import './background.scss'

const Background = () => {
    const { theme } = useTheme();
    return (
        <>

            <section className='background_bg'>
                <div className="custom-container background_main">
                    <div className="logo_heading">
                        <h3 className="brand_common_heading">
                            Backgrounds
                        </h3>
                        <a href='/assets/brandassets/background.zip' className="brand__button" download>Download All</a>
                    </div>
                    <div className="bg_grid">
                        <div className="grid_child" style={theme === LIGHT_THEME ? { border: '1px solid #DEDEDE' } : {}}>
                            <p>Background 1</p>
                           
                                
                              <img src="/assets/brandassets/background/background-1.png" alt="" />
          
                            <a href='/assets/brandassets/background/background-1.png' className='font_btn' download>DOWNLOAD</a>
                        </div>
                        <div className="grid_child" style={theme === LIGHT_THEME ? { border: '1px solid #DEDEDE' } : {}}>
                            <p>Background 2</p>
                            
                                 <img src="/assets/brandassets/background/background-2.png" alt="" />
                 
                            <a href='/assets/brandassets/background/background-2.png' className='font_btn' download>DOWNLOAD</a>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Background